export const ALLOWED_TYPES = [
    'image/png',
    'image/jpeg',
    'image/jpg',
    'image/webp',
    'application/pdf',
    'application/rtf',
    'application/doc',
    'application/docx',
    'application/txt',
    'application/csv',
    'application/xls',
    'application/xlsx',
    'application/ppt',
    'application/pptx',
];

// Currently 8MB, change the non 1024 number to modify up or down.
export const MAX_ATTACHMENT_SIZE = 8 * 1024 * 1024;

export const ERRORS = {
    sizeError: "Invalid File Size (Max Size: 8MB)!",
    typeError: "Invalid File Type!",
    maxError: "Maximum Uploads Reached!",
};